const sharpeningFeaturesJa = {
  // ベンチグラインダー（wb-001〜wb-010）
  product_wb_001_feature_1_title: '革新的な3-in-1多機能設計',
  product_wb_001_feature_1_desc: 'ランダムオービタル、オービタル、マウスサンダーの3種類の交換可能なベースを標準装備。これ一台で広い面の平滑化から縁の仕上げ、狭い角の精密研磨まで完璧に対応します。',
  product_wb_001_feature_2_title: '多段階変速と高効率振動',
  product_wb_001_feature_2_desc: '7000-12000 rpm の調整可能な回転数と、最大 24000 rpm の振動数を実現。木材、プラスチック、金属など、素材に合わせて精密な研磨力を発揮します。',
  product_wb_001_feature_3_title: '自吸機能とクリーンな作業',
  product_wb_001_feature_3_desc: '自吸機能と専用集塵ボックス、掃除機アダプターを装備。作業現場の粉塵を大幅に削減し、呼吸器の健康を守るとともに作業面を清潔に保ちます。',
  product_wb_001_feature_4_title: '優れたバランスと人間工学設計',
  product_wb_001_feature_4_desc: '1.3kg の軽量ボディと低重心バランス設計、さらにトップ部分のソフトグリップにより振動を効果的に低減。長時間の高所作業や垂直面の研磨もストレスなく行えます。',
  product_wb_001_feature_5_title: '充実のアクサセリーセット',
  product_wb_001_feature_5_desc: '3種類のベースプレートと計6枚のサンディングペーパーが付属。開封してすぐに使用でき、木工作業や家具のリフォームを全面的にサポートします。',

  product_wb_002_feature_1_title: '万能な3-in-1研磨システム',
  product_wb_002_feature_1_desc: '3種類の専用アタッチメントを装備し、ドリルビット、ノミ、カンナ刃、さらに家庭用の包丁やハサミまで簡単に研磨可能。これ一台で多目的に活用できます。',
  product_wb_002_feature_2_title: '精密な角度調節機能',
  product_wb_002_feature_2_desc: '角度調節可能なアタッチメントにより、幅 6-51mm のノミやカンナ刃を正確に研磨。プロ級の鋭い切れ味を常に再現できます。',
  product_wb_002_feature_3_title: '高速安定性と安全設計',
  product_wb_002_feature_3_desc: '6700/min の安定した回転数と Ø 51mm の専門研磨ホイールにより、効率的な研磨を実現。保護クラス II 設計で、作業の安全性も万全です。',
  product_wb_002_feature_4_title: 'コンパクトで持ち運びやすい設計',
  product_wb_002_feature_4_desc: 'わずか 1.3kg の軽量・コンパクト設計 (220*183*130mm)。作業台のスペースを取らず、必要な時にすぐに使えるため、家庭用ワークショップに最適です。',
  product_wb_002_feature_5_title: '120W効率的低速モーター',
  product_wb_002_feature_5_desc: '120Wモーターが低速水研削に最適化され、最大の研ぎ効果で最小のエネルギーを使用します。',

  product_wb_003_feature_1_title: '40,000 rpm 極限のパフォーマンス',
  product_wb_003_feature_1_desc: '10,000 から 40,000/min までの広範囲な変速に対応。高硬度素材の彫刻や切断でも、滑らかで精密な仕上がりを保証します。',
  product_wb_003_feature_2_title: '42点のオールインワンアクセサリーセット',
  product_wb_003_feature_2_desc: 'フレキシブルシャフト、ミリングガイド、三脚を含む42点のプロ仕様アクセサリーが付属。研磨、研削、穴あけなどあらゆる作業にこれ一台で対応可能です。',
  product_wb_003_feature_3_title: 'プロ仕様の精密な操作性',
  product_wb_003_feature_3_desc: 'わずか 0.8kg の軽量ボディに LED ワークライトと 3.2mm 精密チャックを搭載。複雑で狭い場所でも、職人級の繊細な操作を自在に行えます。',
  product_wb_003_feature_4_title: '5.5kgアンチスライドベース',
  product_wb_003_feature_4_desc: '5.5kgの本体とゴム防滑フットで積極的な粗目研削中のベンチ移動を防ぎます。',
  product_wb_003_feature_5_title: 'LEDワークライト',
  product_wb_003_feature_5_desc: '統合LEDライトで研削ゾーンを照らし、研ぎ中の正確なベベル角度の観察を可能にします。',

  product_wb_004_feature_1_title: '150mmフレックスシャフトグラインダーコンボ',
  product_wb_004_feature_1_desc: 'フレキシブルシャフト付きのベンチグラインダーで研ぎのリーチを曲線ツール、カービング、不規則なプロファイルに延ばします。',
  product_wb_004_feature_2_title: 'フレキシブルシャフトアタッチメント',
  product_wb_004_feature_2_desc: 'フレックスシャフトアタッチメントでベンチホイールが届かない曲線ガウジ、カービングツール、不規則なプロファイルにアクセスします。',
  product_wb_004_feature_3_title: '200Wフレックスシャフトパワー伝達',
  product_wb_004_feature_3_desc: '200Wモーターがフレキシブルシャフトを通じて一定のパワーを伝達し、複雑なプロファイルツールの効果的な研削を実現します。',
  product_wb_004_feature_4_title: '5.8kg重型ベース',
  product_wb_004_feature_4_desc: '5.8kgのベースでフレックスシャフトが全延伸と角度で使用される際のマシン移動を防ぎます。',
  product_wb_004_feature_5_title: '調整可能フレックスシャフト速度',
  product_wb_004_feature_5_desc: 'フレックスシャフトハンドピースの速度コントロールで異なる研削、磨き、クリーニングアタッチメントのツール速度を調整できます。',

  product_wb_005_feature_1_title: '120W 安定した AC パワーシステム',
  product_wb_005_feature_1_desc: '高効率 120W AC モーターを搭載。持続的で安定したパワーを提供し、長時間の研削や精密研磨作業でも回転数を維持します。',
  product_wb_005_feature_2_title: 'デュアル研磨ホイールとフレキシブルシャフト',
  product_wb_005_feature_2_desc: 'Ø75mm の研削ホイール（#120）と研磨ホイール（#400）を標準装備。粗削りから鏡面仕上げまで対応し、フレキシブルシャフトで高精度な彫刻も可能です。',
  product_wb_005_feature_3_title: '11,500 rpm の高速変速性能',
  product_wb_005_feature_3_desc: '最大回転数 11,500 rpm に達し、精密な変速ノブにより、素材の硬さに合わせて最適な研削速度へ柔軟に切り替えられます。',
  product_wb_005_feature_4_title: '8.0kg産業用安定性',
  product_wb_005_feature_4_desc: '8.0kgの重型産業ベースで高速2900RPM研削中のすべての振動とベンチ移動を排除します。',
  product_wb_005_feature_5_title: '200×25mmプロホイール',
  product_wb_005_feature_5_desc: '幅広25mmのホイール面で広いノミや鉋刃の一定のベベル形成のためのより大きな研削表面を提供します。',

  product_wb_006_feature_1_title: '100mmコンパクトベンチグラインダー',
  product_wb_006_feature_1_desc: '100mmのコンパクトグラインダーはベンチスペースを最小限に抑えながらナイフ、ハサミ、小型ノミを研いだりできます。',
  product_wb_006_feature_2_title: '1450RPM標準速度',
  product_wb_006_feature_2_desc: '標準1450RPMの研削速度で薄い鋼を過熱させずに小さなブレードや切削刃を安全に研ぎます。',
  product_wb_006_feature_3_title: '150Wコンパクトモーター',
  product_wb_006_feature_3_desc: '150Wのコンパクトモーターが100mmホイールに対してサイズが合っており、過剰なエネルギー消費なく効率的な研ぎを実現します。',
  product_wb_006_feature_4_title: '4.0kg軽量ベンチツール',
  product_wb_006_feature_4_desc: '4.0kgは最軽量のベンチグラインダーで、必要なときに取り出せるほど持ち運べます。',
  product_wb_006_feature_5_title: 'スペース節約320mmプロファイル',
  product_wb_006_feature_5_desc: 'コンパクトな320mmのフットプリントで混雑したワークショップのベンチで他のツールとスペースを共有しても支配しません。',

  product_wb_007_feature_1_title: '250mm産業用フロアグラインダー',
  product_wb_007_feature_1_desc: '250mmの産業用ホイールが大型ツール、ブレード、金属材料の重型研削を床置き台座で処理します。',
  product_wb_007_feature_2_title: '600W最大産業パワー',
  product_wb_007_feature_2_desc: '600Wモーターが継続的な産業用研ぎや金属整形アプリケーションのために250mmホイールを駆動します。',
  product_wb_007_feature_3_title: '15kg台座フロア安定性',
  product_wb_007_feature_3_desc: '15kgの床置き台座ですべての振動を排除し、重型研削のための産業レベルの安定性を提供します。',
  product_wb_007_feature_4_title: '1450RPM産業研削',
  product_wb_007_feature_4_desc: '250mmホイールでの1450RPM産業速度ですべての産業アプリケーションにわたって効率的で制御された研削を提供します。',
  product_wb_007_feature_5_title: '5.0N·m最大トルク',
  product_wb_007_feature_5_desc: '5.0N·mのトルクで研削圧力が加わっても重型ツール研削中のホイール速度低下を防ぎ、一定の除去率を維持します。',

  product_wb_008_feature_1_title: '150mmバフィングホイール付きグラインダー',
  product_wb_008_feature_1_desc: 'バフィングホイールアタッチメント付きのベンチグラインダーで研ぎプロセスを磨かれた剃刀のような刃で完了できます。',
  product_wb_008_feature_2_title: '研削+バフィングコンボセットアップ',
  product_wb_008_feature_2_desc: '1台のマシンに研削ホイールとバフィングホイールを組み合わせ、ツール変更なしで完全な研ぎと磨きが可能です。',
  product_wb_008_feature_3_title: '200Wデュアルステーションモーター',
  product_wb_008_feature_3_desc: '200Wが研削とバフィング両ステーションを1450RPMで駆動し、両プロセスで一定のパフォーマンスを発揮します。',
  product_wb_008_feature_4_title: '5.5kgデュアルステーション安定性',
  product_wb_008_feature_4_desc: '5.5kgの本体重量で粗い研削とバフィング操作の両方で安定したプラットフォーム接触を維持します。',
  product_wb_008_feature_5_title: '75dB制御ノイズ',
  product_wb_008_feature_5_desc: '≦75dBの制御されたノイズレベルはノイズが考慮事項であるホームワークショップやガレージに適しています。',

  product_wb_009_feature_1_title: '150mm可変速グラインダー',
  product_wb_009_feature_1_desc: '可変速150mmのベンチグラインダーでホイールRPMを鋼の硬度とベベルの要件に合わせて調整できます。',
  product_wb_009_feature_2_title: '1450RPM可変速オプション',
  product_wb_009_feature_2_desc: '50%からフル1450RPMまでの可変速コントロールで繊細な高炭素鋼の刃先の慎重な研ぎを可能にします。',
  product_wb_009_feature_3_title: '200W可変コントロールモーター',
  product_wb_009_feature_3_desc: '200Wのモーターと電子速度コントロールで任意の設定速度レベルで一定のトルクを提供します。',
  product_wb_009_feature_4_title: '5.2kgコンパクトワークショップグラインダー',
  product_wb_009_feature_4_desc: '5.2kgの基準重量で多用途ワークショップ研ぎツールとしてのポータビリティと安定性のバランスを取ります。',
  product_wb_009_feature_5_title: '74dB低ノイズプロファイル',
  product_wb_009_feature_5_desc: '≦74dBは利用可能な最低ノイズのベンチグラインダーの中にあり、静かなワークショップ環境に適しています。',

  product_wb_010_feature_1_title: '300mm重型産業グラインダー',
  product_wb_010_feature_1_desc: '300mmのプログラインダーで産業スケールのツール研ぎ、溶接研削、重型金属処理を処理します。',
  product_wb_010_feature_2_title: '750W最大産業モーター',
  product_wb_010_feature_2_desc: '750Wモーターはベンチグラインダーシリーズで最高パワーで、300mmホイールを最も硬い鋼を通じて駆動します。',
  product_wb_010_feature_3_title: '20kg床置き台座',
  product_wb_010_feature_3_desc: '20kgの床置き取り付けで重型産業研削中のすべての移動を排除し、一定のプロ品質の結果を実現します。',
  product_wb_010_feature_4_title: '2900RPM最大研削速度',
  product_wb_010_feature_4_desc: '最大ホイールでの2900RPMで産業ツール再整形と重型処理への最大素材除去を提供します。',
  product_wb_010_feature_5_title: '6.0N·m最大トルク出力',
  product_wb_010_feature_5_desc: '6.0N·mの最大トルク出力で最も重いツール研削圧力下でもホイール速度を維持します。',

  // ドリルシャープナー（dr-001〜dr-010）
  product_dr_001_feature_1_title: '120W 安定した AC パワー',
  product_dr_001_feature_1_desc: '高効率 120W AC モーターを搭載。持続的で安定したパワーを提供し、高負荷な研削や研磨作業でも一貫したパフォーマンスを維持します。',
  product_dr_001_feature_2_title: 'デュアルホイールとフレキシブルシャフト',
  product_dr_001_feature_2_desc: 'Ø75mm の研削・研磨ホイールコンビネーションを採用。粗削りと仕上げを同時にこなせ、付属のフレキシブルシャフト で複雑な形状の精密な彫刻も簡単に行えます。',
  product_dr_001_feature_3_title: '11,500 rpm の高速変速制御',
  product_dr_001_feature_3_desc: '0-11,500 rpm の広範囲な変速機能を搭載。素材（金属、木材、ジュエリー）に合わせて回転数を精密に調整でき、最適な仕上がりを実現します。',
  product_dr_001_feature_4_title: '150Wドリルビットモーター',
  product_dr_001_feature_4_desc: '150Wモーターがドリルビット研ぎに適したサイズで、効率的で正確かつ精密な、過剰なパワーなし。',
  product_dr_001_feature_5_title: 'アングルガイドシステム',
  product_dr_001_feature_5_desc: '内蔵アングルガイドで毎回正確なドリルポイント角度の回復を確保し、一定のドリルパフォーマンスを実現します。',

  product_dr_002_feature_1_title: '精密な高速研削性能',
  product_dr_002_feature_1_desc: '高効率 95W モーターを搭載し、1350 rpm の安定した回転を実現。ドリルの刃先を精密に研磨し、新品のような切れ味を維持します。',
  product_dr_002_feature_2_title: '幅広いドリル径に対応',
  product_dr_002_feature_2_desc: '一般的な規格に合わせて設計されており、直径 3-12mm (1/8"-15/32") のさまざまな標準ドリルを研磨できます。',
  product_dr_002_feature_3_title: '軽量でコンパクトな設計',
  product_dr_002_feature_3_desc: '本体重量はわずか 0.95kg。コンパクトなサイズ（210100180mm）で持ち運びが非常に簡単。作業台のスペースを取らず、あらゆる現場に対応します。',
  product_dr_002_feature_4_title: '4.5kg安定重型ベース',
  product_dr_002_feature_4_desc: '4.5kg本体で大きく重いドリルビットをしっかりした手圧力で研ぐ際のシャープナーの移動を防ぎます。',
  product_dr_002_feature_5_title: '精密コレットガイドシステム',
  product_dr_002_feature_5_desc: '精密コレットがドリルビットを正確な研ぎ角度に導き、繰り返し可能な工場品質の結果を実現します。',

  product_dr_003_feature_1_title: '精密な高速研削性能',
  product_dr_003_feature_1_desc: '高効率 95W モーターを搭載し、1350 rpm の安定した回転を実現。ドリルの刃先を精密に研磨し、新品のような切れ味を維持します。',
  product_dr_003_feature_2_title: '幅広いドリル径に対応',
  product_dr_003_feature_2_desc: '一般的な規格に合わせて設計されており、直径 3-12mm (1/8"-15/32") のさまざまな標準ドリルを研磨できます。',
  product_dr_003_feature_3_title: '軽量でコンパクトな設計',
  product_dr_003_feature_3_desc: '本体重量はわずか 0.95kg。コンパクトなサイズ（210100180mm）で持ち運びが非常に簡単。作業台のスペースを取らず、あらゆる現場に対応します。',
  product_dr_003_feature_4_title: '2.0kg最軽量ドリルシャープナー',
  product_dr_003_feature_4_desc: 'わずか2.0kgでこれが最もポータブルなドリルシャープナーで、現場での再研ぎのためにどんな工具箱にも収まります。',
  product_dr_003_feature_5_title: 'シンプルワンステップガイド',
  product_dr_003_feature_5_desc: 'ワンステップガイドシステムで研ぎを素早く簡単にし、ビットを挿入して押すだけで工場出荷時の鋭さを回復します。',

  product_dr_004_feature_1_title: 'より広いドリル径に対応',
  product_dr_004_feature_1_desc: 'Ф3-13mm (1/8-1/2”) 範囲のドリル研磨に対応。他のモデルと比較して、より高い互換性を備えています。',
  product_dr_004_feature_2_title: '効率的で安定したモーター性能',
  product_dr_004_feature_2_desc: '95W モーターを搭載し、回転数は1350rpmに固定。スムーズな研磨プロセスと均一な刃先を実現します。',
  product_dr_004_feature_3_title: 'コンパクトで操作が簡単',
  product_dr_004_feature_3_desc: 'コンパクトな垂直設計とわずか 1kg の重量。精密なポジショニングホールにより、専門家でなくても素早く使いこなせます。',
  product_dr_004_feature_4_title: '4.0kgバランスワークショップツール',
  product_dr_004_feature_4_desc: '4.0kgでビット全サイズ範囲にわたる正確で一定の研ぎのためのワークショップレベルの安定性を提供します。',
  product_dr_004_feature_5_title: 'マルチアングルガイドポジション',
  product_dr_004_feature_5_desc: '複数のガイド角度ポジションで標準と特殊なビット種類の異なるドリルポイントジオメトリに対応します。',

  product_dr_005_feature_1_title: '3〜16mm産業用シャープナー',
  product_dr_005_feature_1_desc: '拡張3〜16mm範囲で金属加工で使用されるコアドリルやアニュラーカッターを含む大型産業ドリルビットをカバーします。',
  product_dr_005_feature_2_title: '200mm大型産業ホイール',
  product_dr_005_feature_2_desc: '200mmホイールで大型16mmや特殊な産業ドリルビットを素早く研ぐための最大研削面積を提供します。',
  product_dr_005_feature_3_title: '250W産業用モーター',
  product_dr_005_feature_3_desc: '250Wの産業用モーターが量産環境での高スループットドリルビットメンテナンスのために200mmホイールを駆動します。',
  product_dr_005_feature_4_title: '6.0kg産業用安定ベース',
  product_dr_005_feature_4_desc: '6.0kgの重型ベースで大径ビット研ぎに必要なしっかりした圧力を加える際の移動を防ぎます。',
  product_dr_005_feature_5_title: '産業用コレットガイドセット',
  product_dr_005_feature_5_desc: '3mmから16mmまでのすべてのビットサイズをカバーするフルコレットガイドセットで任意のビット種類の正確な角度回復が可能です。',

  product_dr_006_feature_1_title: '3〜13mmプロワークショップシャープナー',
  product_dr_006_feature_1_desc: '拡張5.0kgベースを持つプロワークショップシャープナーで3〜13mmドリルビットの正確で安定した研ぎを実現します。',
  product_dr_006_feature_2_title: '200W延長サイクルモーター',
  product_dr_006_feature_2_desc: '200Wモーターが多忙なワークショップでの継続的な研ぎサイクルをモーター熱過負荷なくサポートします。',
  product_dr_006_feature_3_title: '5.0kgプロ安定プラットフォーム',
  product_dr_006_feature_3_desc: '5.0kgのプラットフォームが150mm範囲で最も安定したベースを提供し、プログレードの研ぎ精度を実現します。',
  product_dr_006_feature_4_title: '精密ドリルポイント角度システム',
  product_dr_006_feature_4_desc: '精密角度システムで最適な切削性能のために正確な工場出荷時のドリルポイントジオメトリを回復します。',
  product_dr_006_feature_5_title: '3000RPM一定研ぎ',
  product_dr_006_feature_5_desc: '3000RPMの一定速度で鋭さを回復するための最小限の金属を除去し、ビットのサービス寿命を延ばします。',

  product_dr_007_feature_1_title: '3〜13mm高速シャープナー',
  product_dr_007_feature_1_desc: '高速4500RPMのシャープナーでドリルビットスループットが高い多忙なワークショップのドリルビットあたりの時間を削減します。',
  product_dr_007_feature_2_title: '4500RPM急速研ぎ',
  product_dr_007_feature_2_desc: '4500RPMは標準3000RPMモデルの研ぎ速度の2倍で、素早い回転が必要な多忙なワークショップに最適です。',
  product_dr_007_feature_3_title: '250W高速モーター',
  product_dr_007_feature_3_desc: '250Wモーターが過熱なく4500RPMの研ぎ操作のより高いエネルギー需要を維持します。',
  product_dr_007_feature_4_title: '4.8kg高速安定性',
  product_dr_007_feature_4_desc: '4.8kgのベースがより速い研ぎからの振動を吸収し、4500RPMでの精度を維持します。',
  product_dr_007_feature_5_title: '急速熱放散システム',
  product_dr_007_feature_5_desc: '強化された空冷が高速研ぎ中のドリルビットへの熱伝達を防ぎ、ビットの焼き戻し硬度を保護します。',

  product_dr_008_feature_1_title: '3〜16mm重型シャープナー',
  product_dr_008_feature_1_desc: '300Wの重型マシンが細い精密ビットから大きな16mmの産業ドリルビットまでの完全範囲を処理します。',
  product_dr_008_feature_2_title: '300W最大研ぎパワー',
  product_dr_008_feature_2_desc: '300Wで大きな産業ビットの大量金属除去での速く効率的な研ぎに必要なパワーを提供します。',
  product_dr_008_feature_3_title: '200mm重型ホイール',
  product_dr_008_feature_3_desc: '200mmホイールが大径ビットへの最大研削表面を提供し、必要なパス数を削減します。',
  product_dr_008_feature_4_title: '8.0kg最大安定性',
  product_dr_008_feature_4_desc: '8.0kgは範囲内の最大安定性を提供し、大きな重いドリルビットの正確な研ぎに不可欠です。',
  product_dr_008_feature_5_title: '産業用コレットクランプシステム',
  product_dr_008_feature_5_desc: '重型コレットシステムで大径ビットを確実に固定し、正確で振動なしの高パワー研ぎを実現します。',

  product_dr_009_feature_1_title: '0.5〜6mm精密ミニシャープナー',
  product_dr_009_feature_1_desc: '精密0.5〜6mmシャープナーで微小なPCBドリルビット、時計製作用ドリル、精密エンジニアリングマイクロビットを研ぎます。',
  product_dr_009_feature_2_title: '80mmマイクロ研ぎホイール',
  product_dr_009_feature_2_desc: '80mmのマイクロホイールが最も細いドリルビットに完璧にスケールされ、損傷なく正確な研ぎを提供します。',
  product_dr_009_feature_3_title: '80W精密マイクロモーター',
  product_dr_009_feature_3_desc: '80Wの精密モーターが繊細なマイクロドリルビット研ぎに正確な速度で80mmホイールを動かします。',
  product_dr_009_feature_4_title: '1.5kgポータブル精密ツール',
  product_dr_009_feature_4_desc: '1.5kgのポータブルボディでベンチのどこでも使用でき、マイクロビット研ぎに固定設置は不要です。',
  product_dr_009_feature_5_title: '拡大観察窓',
  product_dr_009_feature_5_desc: '拡大観察窓でマイクロドリルビットの研ぎ前後の正確な視覚的位置合わせを可能にします。',

  product_dr_010_feature_1_title: '3〜20mm最大範囲シャープナー',
  product_dr_010_feature_1_desc: '3〜20mmをカバーする最広範囲のシャープナーで、細いワークショップビットから大型の構造コアビットまですべてのドリルビットを処理します。',
  product_dr_010_feature_2_title: '400W最大パワーシャープナー',
  product_dr_010_feature_2_desc: '400Wの最大研ぎパワーで3mmの細いものから20mmの重型産業ドリルビットまで範囲内のすべてのサイズを処理します。',
  product_dr_010_feature_3_title: '250mmプログレードホイール',
  product_dr_010_feature_3_desc: 'シリーズ最大の250mmホイールで包括的な産業ドリルビット研ぎのための最大表面積を提供します。',
  product_dr_010_feature_4_title: '12kg床置き安定性',
  product_dr_010_feature_4_desc: '12kgの床置きベースで大きな20mmの産業ビットの高圧研ぎ中のすべての移動を排除します。',
  product_dr_010_feature_5_title: '全範囲コレットガイドセット',
  product_dr_010_feature_5_desc: '3mmから20mmまでのすべてのドリルビットサイズ用の完全なコレットガイドセットが付属し、追加購入は不要です。',

  // 彫刻ツール（eg-001〜eg-010）
  product_eg_001_feature_1_title: 'Type-C 充電によるコードレスの自由',
  product_eg_001_feature_1_desc: '4V リチウム電池と汎用性の高い Type-C インターフェースを採用。電源コードの制約から解放され、いつでもどこでも刻印作業が可能です。',
  product_eg_001_feature_2_title: '6 段階の変速制御',
  product_eg_001_feature_2_desc: '6,000 から 19,000/min の広範囲なストローク数に対応。6 段階の変速機能により、素材の硬さに合わせた正確なコントロールが可能です。',
  product_eg_001_feature_3_title: 'コンパクトなボディと充実のインターフェース',
  product_eg_001_feature_3_desc: 'わずか 0.25kg の超軽量ボディに、内蔵 LED ライトとバッテリー残量インジケーターを搭載。暗い場所でも正確な作業をサポートします。',
  product_eg_001_feature_4_title: '0.6kg片手彫刻',
  product_eg_001_feature_4_desc: '0.6kgでこのツールは小さなオブジェクトへの正確な片手彫刻、刻印、ディテール作業に十分な軽さです。',
  product_eg_001_feature_5_title: 'CE/RoHS安全認証',
  product_eg_001_feature_5_desc: 'CEとRoHSの認証取得、ヨーロッパの安全と環境基準に準拠したワークショップや家庭での安全な使用が可能です。',

  product_eg_002_feature_1_title: '精密なペン型操作',
  product_eg_002_feature_1_desc: 'わずか 0.33kg の超軽量設計。人間工学に基づいたペン型グリップにより、長時間でも疲れにくく、繊細な刻印作業に最適です。',
  product_eg_002_feature_2_title: '高速ストローク性能',
  product_eg_002_feature_2_desc: '毎分 6000 回の高速ストロークを実現。金属、ガラス、木材、プラスチックなど、あらゆる素材に鮮明で永久的な刻印が可能です。',
  product_eg_002_feature_3_title: '万能なテンプレートシステム',
  product_eg_002_feature_3_desc: '数字、文字、記号の豊富なテンプレートを標準装備。初心者でも整った美しいプロ級の文字を簡単に刻めます。',
  product_eg_002_feature_4_title: '0.7kgバランス刻印重量',
  product_eg_002_feature_4_desc: '0.7kgのバランスされた重量で金属プレートや宝飾品への長い刻印セッション中の手首疲労を軽減します。',
  product_eg_002_feature_5_title: '70dB低ノイズ回転',
  product_eg_002_feature_5_desc: '≦70dBの静音動作で詳細な芸術作業中にノイズを最小限に抑える必要があるスタジオ環境に適しています。',

  product_eg_003_feature_1_title: '80W高パワー彫刻ツール',
  product_eg_003_feature_1_desc: '80Wの高パワー回転ツールで硬木彫刻、金属刻印、石材ディテールを含む硬い材料を処理します。',
  product_eg_003_feature_2_title: '80W最大彫刻パワー',
  product_eg_003_feature_2_desc: '80Wは最高の単一パワー回転ツールで、積極的な硬木と金属彫刻に必要なトルクを提供します。',
  product_eg_003_feature_3_title: '可変速+前後回転',
  product_eg_003_feature_3_desc: '可変速と組み合わせた前後回転で可能な彫刻および仕上げ技術の範囲を拡大します。',
  product_eg_003_feature_4_title: '5000〜25000RPMフル範囲',
  product_eg_003_feature_4_desc: '1本の強力なツールでゆっくりとした精密作業から最高速切断・刻印までの完全な速度範囲をカバーします。',
  product_eg_003_feature_5_title: '0.25N·m高トルク',
  product_eg_003_feature_5_desc: '0.25N·mのトルクで高パワー80Wツールが負荷下でも速度を維持し、困難な硬木や金属作業に対応します。',

  product_eg_004_feature_1_title: '65W 20Vコードレス彫刻ツール',
  product_eg_004_feature_1_desc: '20Vバッテリー駆動の回転ツールで電源コンセントなしにどこでも彫刻、刻印、研削が可能です。',
  product_eg_004_feature_2_title: '20Vコードレスバッテリープラットフォーム',
  product_eg_004_feature_2_desc: '20Vバッテリーが他のツールと共有でき、彫刻・刻印セットアップのための別の充電器は不要です。',
  product_eg_004_feature_3_title: '5000〜25000RPMコードレス速度',
  product_eg_004_feature_3_desc: 'バッテリーパワーで全可変速度範囲が利用可能、電源ケーブルなしの完全な彫刻・刻印の自由を実現します。',
  product_eg_004_feature_4_title: '0.7kgコードレス彫刻重量',
  product_eg_004_feature_4_desc: 'バッテリー込み0.7kgでツールを片手での精密彫刻・刻印に快適な重さに保ちます。',
  product_eg_004_feature_5_title: '屋外どこでも刻印',
  product_eg_004_feature_5_desc: 'コードレス20V設計で電源アクセスなしの屋外石材刻印、庭の彫刻、現場でのアート作品制作を可能にします。',

  product_eg_005_feature_1_title: '80W高速刻印ツール',
  product_eg_005_feature_1_desc: '80Wで最大30000RPM、金属プレート刻印、ガラスエッチング、精細ディテール作業への高周波刻印を実現します。',
  product_eg_005_feature_2_title: '10000〜30000RPM高速範囲',
  product_eg_005_feature_2_desc: '最大30000RPMの拡張高速範囲でガラスエッチングや石材彫刻アプリケーション向けの精細ダイヤモンドビット刻印を可能にします。',
  product_eg_005_feature_3_title: 'ダイヤモンドビット互換性',
  product_eg_005_feature_3_desc: '高速範囲はガラスエッチング、石材彫刻、宝飾品作業で使用されるダイヤモンド刻印ビット向けに最適化されています。',
  product_eg_005_feature_4_title: '55°C熱保護',
  product_eg_005_feature_4_desc: '熱センサーが55°Cを超えるとツールをシャットオフし、モーターと繊細なワークピースを熱から保護します。',
  product_eg_005_feature_5_title: '80W速度回復モーター',
  product_eg_005_feature_5_desc: '80Wモーターが刻印ビットが材料の抵抗に当たるとすぐに設定速度に回復し、一定のライン品質を実現します。',

  product_eg_006_feature_1_title: '50W精密マイクロ刻印機',
  product_eg_006_feature_1_desc: '2.35mmコレット付きの50W精密刻印機で最小の刻印ビットと最も細かいディテール作業に対応します。',
  product_eg_006_feature_2_title: '2.35mm細コレットサイズ',
  product_eg_006_feature_2_desc: '2.35mmのより小さなコレットサイズで複雑な宝飾品、時計製作、回路基板作業のための超細かい刻印ビットに対応します。',
  product_eg_006_feature_3_title: '0.5kg最軽量彫刻ツール',
  product_eg_006_feature_3_desc: '0.5kgはシリーズ最軽量の回転ツールで、繊細な芸術作品への最大コントロールのための最小重量です。',
  product_eg_006_feature_4_title: '50W細パワーモーター',
  product_eg_006_feature_4_desc: '50Wの低パワーモーターが精密な精細刻印向けに適したサイズで、最小ツール動作が不可欠です。',
  product_eg_006_feature_5_title: '68dB超静音スタジオ使用',
  product_eg_006_feature_5_desc: '≦68dBはシリーズ最静音の回転ツールで、静かなスタジオ環境や宝飾品ワークショップに最適です。',

  product_eg_007_feature_1_title: '80Wデュアルスピード彫刻ツール',
  product_eg_007_feature_1_desc: '80Wのデュアルスピード回転ツールで定義された低速と高速のプリセット間を切り替え、タスクを素早く交互に実行できます。',
  product_eg_007_feature_2_title: '5000〜30000RPM最広範囲',
  product_eg_007_feature_2_desc: '5000〜30000RPMの最広速度範囲で1本のツールですべての彫刻、研削、刻印アプリケーションをカバーします。',
  product_eg_007_feature_3_title: 'デュアルスピードプリセット切替',
  product_eg_007_feature_3_desc: 'クイックアクセスデュアルスピード切替でダイヤルを見ずにプリセットの遅速と高速を切り替えられます。',
  product_eg_007_feature_4_title: '0.8kg拡張コントロールボディ',
  product_eg_007_feature_4_desc: '0.8kgの拡張本体で大型木彫りや面への持続的な彫刻セッションのレバレッジを向上します。',
  product_eg_007_feature_5_title: '延長212mmコントロール長さ',
  product_eg_007_feature_5_desc: '212mmの長い本体で直線彫刻ラインや一定の深さ刻印のための片手での制御を向上します。',

  product_eg_008_feature_1_title: '65W大型6mmコレットルーター',
  product_eg_008_feature_1_desc: '65Wの回転ツールに大型6mmコレットを組み合わせ、木工ディテールルーティングやインレイ切削のためのより大きなルーティングビットを受け入れます。',
  product_eg_008_feature_2_title: '6mm大コレットルーティング能力',
  product_eg_008_feature_2_desc: '6mmコレットで木工ディテールルーティング、インレイ、エッジ作業のためのより大きく積極的なルーティングビットに対応します。',
  product_eg_008_feature_3_title: '5000〜25000RPMルーティング速度',
  product_eg_008_feature_3_desc: '6mmルーティング・彫刻ビット範囲に最適化された可変速度でコントロール用に遅く、クリーンな材料除去用に速く設定できます。',
  product_eg_008_feature_4_title: '0.22N·mルーティングトルク',
  product_eg_008_feature_4_desc: '0.22N·mのトルクで6mmビットが緻密な硬木木目に接触しても一定のルーティング速度を維持します。',
  product_eg_008_feature_5_title: '205mm精密ルーティング長さ',
  product_eg_008_feature_5_desc: '205mm本体でフェンスやテンプレートアタッチメントを使用したガイド付き直線ルーティングに必要なコントロールを提供します。',

  product_eg_009_feature_1_title: '80W往復彫刻ツール',
  product_eg_009_feature_1_desc: '80Wの往復アクションで木材、石材、硬化材料への制御されたハンマーノミ彫刻を実現します。',
  product_eg_009_feature_2_title: '3000〜8000SPM彫刻速度',
  product_eg_009_feature_2_desc: '3000〜8000SPMの往復速度で精密な石材彫刻や木材レリーフ作業に必要なコントロールを提供します。',
  product_eg_009_feature_3_title: '往復ノミアクション',
  product_eg_009_feature_3_desc: '往復アクションで木ノミを模倣し、石材、硬木、複合材への制御された材料除去を実現します。',
  product_eg_009_feature_4_title: '0.25N·mインパクト彫刻トルク',
  product_eg_009_feature_4_desc: '往復モードでの0.25N·mのトルクが石材の刻字や硬木レリーフのための効果的なノミ切り力を提供します。',
  product_eg_009_feature_5_title: '68dB静音ノミ彫刻',
  product_eg_009_feature_5_desc: '≦68dBの静音動作でこの往復彫刻機をスタジオや住宅ワークショップ環境に適したものにします。',

  product_eg_010_feature_1_title: '80Wプロ彫刻システム',
  product_eg_010_feature_1_desc: '80Wのプロ回転彫刻システムでアーティスト、工芸家、修復師のための総合アクセサリーセット付き。',
  product_eg_010_feature_2_title: '5000〜25000RPMプロ範囲',
  product_eg_010_feature_2_desc: '5000〜25000RPMのフルプロ速度範囲ですべての彫刻、研削、切断、磨きアプリケーションをカバーします。',
  product_eg_010_feature_3_title: 'プロアクセサリーバンドル',
  product_eg_010_feature_3_desc: '彫刻ビット、砥石、カットオフホイール、磨きパッドを含む総合プロアクセサリーセットが付属します。',
  product_eg_010_feature_4_title: '215mmプロコントロール長さ',
  product_eg_010_feature_4_desc: '215mmの拡張本体で持続的なプロ彫刻セッションに必要な片手でのコントロールを提供します。',
  product_eg_010_feature_5_title: '12ヶ月プロ保証',
  product_eg_010_feature_5_desc: 'CE・RoHS認証付き12ヶ月保証で毎日のスタジオ使用でのプロアーティストや工芸家をサポートします。',

  // ===== 研磨工具アクセサリー翻訳 (sp_acc_* シリーズ) =====
  sp_acc_diamond_wheels_name: 'ダイヤモンド砥石セット',
  sp_acc_diamond_wheels_desc: '粗目・中目・細目のダイヤモンド研削砥石セット、完全な研ぎワークフローに対応',
  sp_acc_angle_guide_name: '精密角度ガイドレール',
  sp_acc_angle_guide_desc: '15°〜45°調整可能な精密角度ガイドジグ、一定で正確な研削角度を確保',
  sp_acc_honing_compound_name: 'ホーニング研磨コンパウンド',
  sp_acc_honing_compound_desc: 'プロ仕様酸化アルミニウム研磨ペースト、細かい傷を除去し刃先の鋭さを回復',
  sp_acc_blade_clamp_name: 'ユニバーサルブレードクランプ',
  sp_acc_blade_clamp_desc: '幅調整可能なステンレス製ブレードクランプジグ、研削中の確実なブレード保持',
  sp_acc_dressing_tool_name: '砥石ドレッシングツール',
  sp_acc_dressing_tool_desc: 'ダイヤモンドチップ星形ホイールドレッサー、砥石の平坦度と研削効率を回復',
  sp_acc_work_mat_name: '滑り止め作業マット',
  sp_acc_work_mat_desc: '滑り止めゴム製ワークベンチマット、振動吸収とベンチ移動防止',
  sp_acc_angle_gauge_name: 'デジタル角度計',
  sp_acc_angle_gauge_desc: 'LCD表示磁気ベースデジタル角度計、正確なブレード研削角度測定用',
  sp_acc_sharpening_manual_name: '研磨参考ガイド',
  sp_acc_sharpening_manual_desc: '各種ツールの推奨研削角度参考ブックレット、最適パラメーターの素早い確認用',
  sp_acc_whetstone_set_name: '水冷砥石',
  sp_acc_whetstone_set_desc: '天然水冷矩形砥石、熱変形を防ぎスチールの焼き戻しを保持',
  sp_acc_water_trough_name: '水冷槽',
  sp_acc_water_trough_desc: '湿式グラインダー専用貯水槽、砥石を持続冷却して刃先の過熱を防止',
  sp_acc_leather_strop_name: 'レザーストロッピングホイール',
  sp_acc_leather_strop_desc: '本革ストロッピングホイール、最終仕上げ刃磨きでカミソリ級の鋭さを実現',
  sp_acc_digital_caliper_name: 'デジタルノギス',
  sp_acc_digital_caliper_desc: 'LCD表示150mmステンレス製デジタルノギス、正確なブレードと研削パラメーター測定用',
  sp_acc_carry_case_name: 'ポータブルキャリーケース',
  sp_acc_carry_case_desc: '硬質シェルフォームライニングキャリーケース、ツールとアクセサリーの安全な保管と持ち運び用',
  sp_acc_grinding_oil_name: '研削潤滑オイル',
  sp_acc_grinding_oil_desc: '500ml金属研削切削潤滑オイル、防腐防錆、砥石の寿命を延長',
  sp_acc_heavy_clamp_name: '重型バイス',
  sp_acc_heavy_clamp_desc: '鋳鉄製重型ベンチバイス、大型ツール研削時の産業グレードの確実な把持',
  sp_acc_smart_sensor_name: 'スマート角度センサー',
  sp_acc_smart_sensor_desc: 'デジタル角度プローブセンサー、ブレード形状を自動識別して精密研削をサポート',

  // ドリルビット修復機アクセサリー
  sp_acc_grinding_wheel_dr_name: '交換用研削ホイール',
  sp_acc_grinding_wheel_dr_desc: 'ドリルシャープナー専用設計の80目酸化アルミニウム研磨ホイール',
  sp_acc_collet_set_name: 'コレットチャックセット',
  sp_acc_collet_set_desc: '多サイズ精密コレットセット（3/6/8/10/13mm）、各種ドリルビット径に対応',
  sp_acc_drill_bit_set_name: 'ツイストドリルビットセット',
  sp_acc_drill_bit_set_desc: 'HSS高速度鋼ツイストドリルビットセット、1〜13mm多種サイズ、収納ケース付き',
  sp_acc_cleaning_brush_name: 'クリーニングブラシセット',
  sp_acc_cleaning_brush_desc: '金属ブラシ＋ナイロン軟ブラシクリーニングセット、研削屑除去と機器清潔維持',
  sp_acc_cutting_oil_name: '切削研削オイル',
  sp_acc_cutting_oil_desc: '300mlドリルビット研磨専用金属切削液、潤滑・冷却・防錆',
  sp_acc_drill_holder_name: 'ドリルビット収納ラック',
  sp_acc_drill_holder_desc: 'サイズ別スロット付き金属ドリルビット収納ラック、整理整頓と素早い取り出しに便利',
  sp_acc_safety_goggles_name: '保護ゴーグル',
  sp_acc_safety_goggles_desc: '透明レンズ保護ゴーグル、研削屑や金属片から目を守る',
  sp_acc_guide_rail_name: '精密ガイドレールフィクスチャ',
  sp_acc_guide_rail_desc: 'ベンチ取り付け精密ガイドアラインメントフィクスチャ、正確な角度でのドリルビット研削を確保',
  sp_acc_step_bit_set_name: 'ステップドリルビットセット',
  sp_acc_step_bit_set_desc: 'チタンコートHSSステップコーンドリルビットセット、4〜32mm範囲の多用途使用',
  sp_acc_auto_feed_belt_name: 'オートフィードドライブベルト',
  sp_acc_auto_feed_belt_desc: 'オートフィードドリルシャープナー用ゴム駆動ベルト、安定したフィードのため定期交換',
  sp_acc_diamond_wheel_fine_name: '細粒ダイヤモンド研削ホイール',
  sp_acc_diamond_wheel_fine_desc: '120目細粒ダイヤモンドホイール、高速対応でドリル先端の精密仕上げ研削に最適',
  sp_acc_cnc_probe_name: 'CNCタッチプローブ',
  sp_acc_cnc_probe_desc: 'デジタルCNCタッチプローブ、CNCドリルプログラムの正確な校正と位置決め',
  sp_acc_micro_grinding_wheel_name: 'マイクロ精密研削ホイール',
  sp_acc_micro_grinding_wheel_desc: '600目細粒マイクロホイール、小径ドリルシャープナー専用の超精密研削',
  sp_acc_micro_collet_set_name: 'マイクロコレットセット',
  sp_acc_micro_collet_set_desc: '0.5/1/1.5/2/3mmマイクロコレットセット、精密小径ドリルビットの固定用',
  sp_acc_micro_drill_set_name: 'マイクロドリルビットセット',
  sp_acc_micro_drill_set_desc: 'PCB・宝飾品・時計製作用HSS 0.5〜3mmマイクロドリルビットセット、専用ケース付き',
  sp_acc_magnifier_loupe_name: '拡大ルーペ',
  sp_acc_magnifier_loupe_desc: '10倍宝飾商用ルーペ、マイクロドリル先端の位置合わせ精密検査用',

  // 彫刻ツールアクセサリー
  sp_acc_engraving_bit_set_name: '彫刻ビットセット',
  sp_acc_engraving_bit_set_desc: '50本タングステンカーバイド回転バーセット、球形/錐形/円柱形など全彫刻ニーズに対応',
  sp_acc_collet_set_eg_name: '彫刻ツールコレットセット',
  sp_acc_collet_set_eg_desc: '多サイズ彫刻ツール専用コレットセット（1/2/3/3.17mm）、素早いビット交換用',
  sp_acc_flexible_shaft_name: 'フレキシブルシャフト延長',
  sp_acc_flexible_shaft_desc: '1mフレキシブル駆動シャフト、彫刻ツールのリーチを延ばし難しい角度にアクセス',
  sp_acc_work_stand_name: 'ツール吊り下げスタンド',
  sp_acc_work_stand_desc: '調整可能な金属吊り下げスタンド、使用しない際に彫刻ツールを垂直に収納',
  sp_acc_polishing_compound_name: '金属研磨コンパウンド',
  sp_acc_polishing_compound_desc: '白・緑・赤色研磨コンパウンドセット、多段階金属表面仕上げでミラー品質を実現',
  sp_acc_dust_collector_name: '集塵シールド',
  sp_acc_dust_collector_desc: '透明プラスチック集塵ガード、彫刻屑を捕集して作業台をきれいに保つ',
  sp_acc_storage_case_eg_name: 'ツール収納ケース',
  sp_acc_storage_case_eg_desc: 'フォームライニングジッパー収納ケース、彫刻ツールと全アクセサリーの整理整頓収納',
  sp_acc_lithium_battery_eg_name: 'リチウムバッテリー',
  sp_acc_lithium_battery_eg_desc: '20V 2Ah充電式リチウムバッテリー、コードレス彫刻ツールへの継続的な電力供給',
  sp_acc_charger_eg_name: 'バッテリー充電器',
  sp_acc_charger_eg_desc: 'LEDステータスインジケーター付き20Vリチウム急速充電器、効率的で安全な充電',
  sp_acc_wood_carving_bits_name: '木彫り専用ビット',
  sp_acc_wood_carving_bits_desc: '木材木目に最適化されたHSS高速度鋼木彫り回転ビットセット、球形/炎形/円筒形',
  sp_acc_metal_engraving_bits_name: '金属彫刻ビット',
  sp_acc_metal_engraving_bits_desc: 'カーバイドダイヤモンドコート金属彫刻ビット、鋼・アルミ・銅表面のマーキングと装飾用',
  sp_acc_micro_bit_set_eg_name: 'マイクロ彫刻ビットセット',
  sp_acc_micro_bit_set_eg_desc: '宝飾品・時計製作用0.5/1mmダイヤモンドマイクロ彫刻ビット、超精細ディテール作業用',
  sp_acc_micro_collet_eg_name: 'マイクロコレット',
  sp_acc_micro_collet_eg_desc: '最小ビットでの超精細彫刻作業用0.5〜1.5mm精密マイクロコレット',
};

export default sharpeningFeaturesJa;
